import ReactDOM from 'react-dom'
import App from './App'

declare global {
	interface Window {
		clevertap: any
		dataLayer: any
		setInterval: any
	}
}

ReactDOM.render(<App />, document.getElementById('root'))
